// Local storage keys
export const AUTH_TOKEN_KEY = 'auth_token';

// API constants
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || (window.location.host.includes('.dev.') ? 'https://engine-dev.cinch.io/loyalty' : 'https://engine.cinch.io/loyalty');
